<footer class="layout-column">
  <div class="layout-column">
    <!-- Logo -->
    <span>Copyright ©2024 Body Of 9. All rights reserved.</span><a href="/#/login">Login</a>
  </div>
</footer>
